export const enum PeopleSecondaryMenuItems {
  COMPANIES = 'companies',
  COMPANIES_GRID = 'companiesGrid',
  BLOCKED_COMPANIES_GRID = 'blockedCompaniesGrid',
  PERFORMERS = 'performers',
  CLIENTS = 'clients'
}
